const getFontFamily = role => role === "heading" ? "Value Serif Pro" : "Mabry Pro";
export { getFontFamily };
//# sourceMappingURL=fonts.mjs.map
